/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_NetworkInputs */

const de_auth_mfa_error_network = /** @type {(inputs: Auth_Mfa_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es erneut.`)
};

/** @type {(inputs: Auth_Mfa_Error_NetworkInputs) => LocalizedString} */
const en_auth_mfa_error_network = de_auth_mfa_error_network;

/**

* @param {Auth_Mfa_Error_NetworkInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_network = /** @type {((inputs?: Auth_Mfa_Error_NetworkInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_NetworkInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_network(inputs)
	return en_auth_mfa_error_network(inputs)
});